import { makeAutoObservable } from 'mobx'
import { me } from 'store/me'
import { EmailFormStore } from 'store/profile/EmailFormStore'
import { PhoneFormStore } from 'store/profile/PhoneFormStore'
import { store } from 'store/store'
import { minAsync } from 'util/async'
import { load, save } from 'util/storage'

const STORAGE_KEY = 'banner'

function getType(): 'email' | 'phone' {
  const type = store.options?.email?.type
  return type === 'phone' ? 'phone' : 'email'
}

function getShowDelay(): number {
  const sec = store.options?.email?.delay ?? 0
  return sec * 1000
}

function getSilentTimeout() {
  const hour = store.options?.email?.timeout ?? 0
  return hour * 60/*min*/ * 60/*sec*/ * 1000
}

export class UserDataBannerStore {
  open = false
  done = false
  email = new EmailFormStore()
  phone = new PhoneFormStore()
  private showTimeout?: TimeoutId

  constructor() {
    makeAutoObservable(this)
  }

  close() {
    const now = Date.now()
    save(STORAGE_KEY, now.toFixed())
    this.open = false
  }

  cancel() {
    this.open = false
    clearTimeout(this.showTimeout)
  }

  reset() {
    this.open = false
    save(STORAGE_KEY, undefined)
  }

  readonly showMaybe = minAsync(async () => {
    if (this.open) return

    const email = getType() === 'email'
    if (email && me.email) return

    const text = load(STORAGE_KEY)
    const latest = text ? parseInt(text, 10) || 0 : 0
    const now = Date.now()
    if (now - latest < getSilentTimeout()) return

    this.cancel()

    const delay = Math.max(1000, getShowDelay())
    this.showTimeout = setTimeout(() => this.show(), delay)
  })

  private show() {
    this.open = true
    this.done = false
    this.email.reset()
    this.phone.reset()
  }
}
